var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-nav"},[_c('router-link',{attrs:{"to":"controlpanel"}},[_vm._v("Kontrollpanel")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }